<ng-container *transloco="let t; prefix: scope">
  <h2 mat-dialog-title>{{ t('titleSwitchAccount') }}</h2>

  <rma-icon class="top-modal-close" glyph="close" mat-dialog-close />

  <mat-dialog-content class="!flex flex-col !overflow-hidden border-t border-steel-20 !pb-1">
    <mat-tab-group
      class="mb-4"
      [selectedIndex]="selectedTabIndex()"
      (selectedIndexChange)="onTabSelected($event)"
      mat-stretch-tabs="false"
      mat-align-tabs="start"
    >
      <mat-tab [label]="t('tabs.agent')" />
      <mat-tab [label]="t('tabs.agency')" />
    </mat-tab-group>

    <mat-form-field class="w-full" subscriptSizing="dynamic">
      @if (loading()) {
        <rma-icon class="animate-spin" glyph="sync" matSuffix size="small" />
      }
      <rma-icon glyph="search" matPrefix size="small" />
      <input #searchTerm [placeholder]="t('placeholder.' + profileType() | lowercase)" [value]="searchTermValue()" matInput />
    </mat-form-field>

    <div
      class="mt-4 flex grow flex-col gap-4 overflow-y-auto overflow-x-hidden pl-2 pr-4 md:max-h-full"
      [style.scrollbar-width]="'thin'"
      [scrollWindow]="false"
      (scrolled)="loadMore()"
      infiniteScroll
    >
      @for (profile of profiles(); track profile.profileType + profile.profileCode) {
        <rma-profile-switch-item
          [activeProfile]="currentProfile()"
          [defaultProfile]="defaultProfile()"
          [profile]="profile"
          [searchTerm]="searchTermValue()"
          [isAssisting]="isAssisting()"
          (switchProfile)="onSwitchAccount($event)"
          (manageAccount)="onManageAccount($event.profile, $event.agentName)"
          (stopAssisting)="onStopAssisting()"
        />
      }

      @if (showNoFilteredProfilesCta()) {
        <rma-no-profiles-found [title]="t('noMatchingProfiles.title', { term: searchTermValue() })" [body]="t('noMatchingProfiles.body')" />
      }

      @if (showNoAvailableProfilesCta()) {
        <rma-no-profiles-found
          [title]="t('noAvailableProfiles.title', { term: searchTermValue() })"
          [body]="t('noAvailableProfiles.body')"
          [cta]="t('noAvailableProfiles.cta')"
          (navigate)="onNavigate()"
        />
      }

      @if (loading()) {
        @for (_ of [].constructor(take - 2); track $index) {
          <rma-skeleton-block class="flex h-20" />
        }
      }

      @if (loadingError()) {
        <rma-callout class="my-4" theme="error">
          <span>{{ t('error') }}</span>
        </rma-callout>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (currentProfile().profileType === 'Team' || currentProfile().profileType === 'Office') {
      <a mat-button color="primary" routerLink="/manage-account" data-id="manage-account" mat-dialog-close>
        <rma-icon glyph="settings" theme="primary" matButtonIcon />{{ t('manageAccount') }}
      </a>
    } @else {
      @if (!isAssisting()) {
        <a mat-button color="primary" routerLink="/manage-account" data-id="manage-account" mat-dialog-close>
          <rma-icon glyph="local_atm" theme="primary" matButtonIcon />{{ t('billingAndSubs') }}
        </a>
      }
    }

    <button type="button" (click)="onLogout()" mat-button color="primary" data-id="logout">
      <rma-icon glyph="exit_to_app" matButtonIcon />{{ t('logout') }}
    </button>
  </mat-dialog-actions>
</ng-container>
